




















import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import Query from '../../../components/query/queryHeard.vue'
import addModal from './addModal.vue'
import detail from './detail.vue'
import {QueryMaterials,QuerySysDic} from '../../../api/material'
import {QueryManufacturer,CreateManufacturer,EditManufacturer} from '../../../api/basicDictionary'
import {QueryStockActionList,CheckStockAction,BillingStockAction} from '../../../api/storehouse'
import util from '../../../lib/util'
@Component({
  components:{myTable,Query,addModal,detail}
})
export default class extends AbpBase{
    list:Array<object> = []
    addModalShow:boolean = false
    addModalData:object = null

    detailModalShow:boolean = false
    detailModalData:object = null

    actionType = 1
    //操作类型
    actionTypeOptions:any = [
        {value:1,text:'入库'},
        {value:2,text:'出库'},
        {value:3,text:'报损'},
        {value:4,text:'盘点'},
    ]
    @Watch('$route')
    async routerWacth(){
        this.actionType = this.$route.meta.type
        this.renderColumns()
        await this.getSelects()
        this.getData()   
    }
    
    
    conditions:any = []
    async created() {
        console.log(this.actionType)
        this.actionType = this.$route.meta.type
        this.renderColumns()
        await this.getSelects()
        this.getData()   
    }
    get actionName(){
        console.log(this.actionType)
        console.log(this.actionTypeOptions)
        return this.actionTypeOptions.find((item:any)=>{return item.value == this.actionType}).text
    }
    itemTypeOptions:any = []
    statusOptions:any = [
        {value:1,text:'暂存'},
        {value:2,text:'核对'},
        {value:3,text:'记账'},
    ]
    //获取条件下拉框
    async getSelects(){
        this.itemTypeOptions = (await QuerySysDic({dataType:1,status:true,typeName:''})).data
        this.conditions = [
            {
                name:'itemType',
                dataType:6,
                value:null,
                label:this.actionName+'类型',
                options:this.itemTypeOptions.map((item:any)=>{
                    return {
                        value:item.id,
                        text:item.typeName,
                    }
                })
            },
            {
                name:'receiptNo',
                dataType:1,
                value:null,
                label:this.actionName+'单号',
            },
            {
                name:'dateTimeBegin',
                dataType:10,
                value:null,
                label:this.actionName+'日期',
                valueFormat:'yyyy-MM-dd'
            },
            {
                name:'status',
                dataType:6,
                value:null,
                label:'单据状态',
                options:this.statusOptions
            },
        ]
    }
    async getData(){
        this.table.loading = true
        let search = {}
        this.conditions.forEach((item:any)=>{
            //日期区间特殊处理
            if(item.dataType===10){
                search['dateTimeBegin'] = item.value?item.value[0]:''
                search['dateTimeEnd'] = item.value?item.value[1]:''
            }else if(item.dataType===6){
                search['itemType'] = item.value?item.value:0
                search['status'] = item.value?item.value:0
            }else{
                search[item.name] = item.value
            }
        })
        let data = {
            ...this.table,
            ...search,
            actionType:this.actionType
        }
        let res = await QueryStockActionList(data)
        this.table.totalCount = res.data.totalCount;
        this.list = res.data.items;
        this.table.loading = false
    }
    pageChange(page:number){
        this.table.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.table.pageSize = pagesize
        this.getData();
    }
    detail(row:any){
        this.detailModalData = row
        this.detailModalShow = true
    }
    add(row:any){
        this.addModalData = row
        this.addModalShow = true
    }
    async check(row:any){
        let res = await CheckStockAction({actionId:row.actionId})
        if(res.code==2000){
            this.getData()
        }
    }
    async billing(row:any){
        let res = await BillingStockAction({actionId:row.actionId})
        if(res.code==2000){
            this.getData()
        }
    }

    renderColumns(){
        this.columns = [
            {
                title:this.actionName+'类型',
                render:(h:any,p:any)=>{
                    return h('span',this.itemTypeOptions.find((item:any)=>{return item.id == p.row.itemType}).typeName)
                }
            },
            {title:this.actionName+'单号',key:'receiptNo'},
            {
                title:this.actionName+'日期',
                key:'operDateTime',
                render:(h:any,p:any)=>{
                    return h('span',util.formatTime(p.row.operDateTime))
                }
            },
            {title:this.actionName+'人',key:'createUserName'},
            {title:'供货商',key:'supplierName',isHidden:this.actionType==1?false:true},
            {
                title:'单据状态',
                key:'status',
                render:(h:any,p:any)=>{
                    return h('el-tag',{
                        props:{
                            type: p.row.status===1?'info':p.row.status===2?'warning':'success',
                        },
                    },this.statusOptions.find((item:any)=>{return item.value == p.row.status}).text)
                }
            },
            {title:'核对人',key:'checkUserName'},
            {title:'记账人',key:'billingUserName'},
            {
                title:'操作',
                width:'180',
                render:(h:any,p:any)=>{
                    return h('div',[
                        h('el-button',{
                            props:{
                                type:'text',
                                size:'small',
                                disabled:p.row.status!==1
                            },
                            directives:[{
                                name:'allow'
                            }],
                            style:{
                                marginRight:'5px'
                            },
                            on:{
                                click:()=>{
                                    this.add(p.row)
                                }
                            }
                        },'编辑'),
                        h('el-button',{
                            props:{
                                type:'text',
                                size:'small',
                                disabled:p.row.status!==1
                            },
                            directives:[{
                                name:'allow'
                            }],
                            style:{
                                marginRight:'5px'
                            },
                            on:{
                                click:()=>{
                                    this.check(p.row)
                                }
                            }
                        },'核对'),
                        h('el-button',{
                            props:{
                                type:'text',
                                size:'small',
                                disabled:p.row.status!==2
                            },
                            directives:[{
                                name:'allow'
                            }],
                            style:{
                                marginRight:'5px'
                            },
                            on:{
                                click:()=>{
                                    this.billing(p.row)
                                }
                            }
                        },'记账'),
                        h('el-button',{
                            props:{
                                type:'text',
                                size:'small'
                            },
                            directives:[{
                                name:'allow'
                            }],
                            on:{
                                click:()=>{
                                    this.detail(p.row)
                                }
                            }
                        },'详情')
                    ])
                }
            },
        ]
    }
    columns:Array<object> = []
}
